(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initFAQ();
    initMobileMenu();
    initQtySelector();
    initShopFilters();
    initGalleryThumbs();
  });

  function initFAQ() {
    document.querySelectorAll('.szc-faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer = this.nextElementSibling;
        var isOpen = this.classList.contains('open');
        document.querySelectorAll('.szc-faq-question').forEach(function (q) {
          q.classList.remove('open');
          q.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.szc-faq-answer').forEach(function (a) { a.classList.remove('show'); });
        if (!isOpen) {
          this.classList.add('open');
          this.setAttribute('aria-expanded', 'true');
          answer.classList.add('show');
        }
      });
    });
  }

  function initMobileMenu() {
    var btn = document.querySelector('.szc-mobile-menu-btn');
    var nav = document.querySelector('.szc-mobile-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var isHidden = nav.hasAttribute('hidden');
      if (isHidden) {
        nav.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        nav.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initQtySelector() {
    var selector = document.querySelector('.szc-qty-selector');
    if (!selector) return;
    var input = selector.querySelector('input[name="quantity"]');
    if (!input) return;

    // ── Order rules ────────────────────────────────────────────────────
    // • Default / standard order: 300 units
    // • Step / multiple: 20 (all quantities must be multiples of 20)
    // • Absolute minimum: 100 (user may order less than 300, but never below 100)
    // ───────────────────────────────────────────────────────────────────
    var STEP    = parseInt(selector.dataset.step, 10)       || parseInt(input.getAttribute('step'), 10) || 20;
    var MIN_QTY = parseInt(selector.dataset.minQty, 10)     || parseInt(input.getAttribute('min'),  10) || 100;

    var minus = selector.querySelector('.szc-qty-minus');
    var plus  = selector.querySelector('.szc-qty-plus');

    /** Clamp to [MIN_QTY, ∞) and snap to nearest STEP multiple. */
    function clamp(raw) {
      var snapped = Math.round(raw / STEP) * STEP;
      return Math.max(MIN_QTY, snapped);
    }

    function updatePrice(qty) {
      var btn = document.querySelector('.szc-atc-btn');
      if (!btn) return;
      var packEach = parseFloat(btn.dataset.packEach) || 0;
      var boxEach  = parseFloat(btn.dataset.boxEach)  || 0;
      var boxQty   = parseInt(btn.dataset.boxQty, 10) || 0;
      var rate = (boxQty > 0 && qty >= boxQty) ? boxEach : packEach;
      btn.textContent = 'Add to Cart \u2014 $' + (rate * qty).toFixed(2);
    }

    function syncBuyNow(qty) {
      var form = document.getElementById('szc-buy-now-form');
      if (!form) return;
      var inp = form.querySelector('input[name="quantity"]');
      if (inp) inp.value = qty;
    }


    function applyQty(v) {
      input.value = v;
      updatePrice(v);
      syncBuyNow(v);
      // Disable minus button at absolute floor
      if (minus) minus.disabled = (v <= MIN_QTY);
    }

    if (minus) minus.addEventListener('click', function () {
      var current = parseInt(input.value, 10) || MIN_QTY;
      applyQty(clamp(current - STEP));
    });

    if (plus) plus.addEventListener('click', function () {
      var current = parseInt(input.value, 10) || MIN_QTY;
      applyQty(clamp(current + STEP));
    });

    input.addEventListener('change', function () {
      applyQty(clamp(parseInt(this.value, 10) || MIN_QTY));
    });

    // Initialise with current value already set in HTML (300)
    var initQty = clamp(parseInt(input.value, 10) || MIN_QTY);
    applyQty(initQty);
  }

  function initShopFilters() {
    var sizeButtons = document.querySelectorAll('[data-filter-size]');
    var colorButtons = document.querySelectorAll('[data-filter-color]');
    var sortSelect = document.querySelector('[data-sort-select]');
    var cards = Array.from(document.querySelectorAll('[data-product-card]'));
    var countEl = document.querySelector('.szc-shop-count');
    if (!cards.length) return;

    var activeSize = 'All';
    var activeColor = 'All';

    function applyFilters() {
      var sorted = cards.slice();
      var sortVal = sortSelect ? sortSelect.value : 'featured';
      if (sortVal === 'price-asc') sorted.sort(function (a, b) { return parseFloat(a.dataset.price) - parseFloat(b.dataset.price); });
      if (sortVal === 'price-desc') sorted.sort(function (a, b) { return parseFloat(b.dataset.price) - parseFloat(a.dataset.price); });
      if (sortVal === 'name') sorted.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title); });

      var grid = document.getElementById('szc-product-grid');
      if (grid) sorted.forEach(function (c) { grid.appendChild(c); });

      var visible = 0;
      sorted.forEach(function (card) {
        var cardSize = (card.dataset.size || '').trim().toLowerCase().replace(/-/g, ' ');
        var filterSize = activeSize.trim().toLowerCase().replace(/-/g, ' ');
        var sizeMatch = activeSize === 'All' || cardSize === filterSize;

        var cardColor = (card.dataset.color || '').trim().toLowerCase().replace(/-/g, ' ');
        var filterColor = activeColor.trim().toLowerCase().replace(/-/g, ' ');
        var colorMatch = activeColor === 'All' || cardColor === filterColor;

        var show = sizeMatch && colorMatch;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible + ' product' + (visible !== 1 ? 's' : '');
    }

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeButtons.forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        activeSize = this.dataset.filterSize;
        applyFilters();
      });
    });

    colorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        colorButtons.forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        activeColor = this.dataset.filterColor;
        applyFilters();
      });
    });

    if (sortSelect) sortSelect.addEventListener('change', applyFilters);
  }

  function initGalleryThumbs() {
    var thumbs = document.querySelectorAll('.szc-gallery-thumb');
    var mainImg = document.querySelector('.szc-product-gallery-main img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        mainImg.src = this.dataset.src;
        mainImg.alt = this.dataset.alt || '';
      });
    });
  }

  function initAddToCartPrice() {
    updateATC(1);
  }

})();
